import { useQuery } from '@tanstack/react-query';
import { agreementsService } from '../services/agreementsService';
import { agreementKeys } from './queryKeys';
import type { Agreement } from '../types';

export function useAgreements() {
  return useQuery<Agreement[]>({
    queryKey: agreementKeys.list(),
    queryFn: agreementsService.getAll,
  });
}
